import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const taskEvidenceExceptionDialogStyleId = 'work-task-evidence-exception-dialog-theme';

export const taskEvidenceExceptionDialogBridgeStyles = {
  'task-evidence-exception-dialog': {
    '--local-exception-dialog-bg': tokens.color.background.primary,
    '--local-exception-dialog-title': tokens.color.text.primary,
    '--local-exception-dialog-body': tokens.color.text.secondary,
    '--local-exception-dialog-label': tokens.color.text.secondary,
    '--local-exception-dialog-value': tokens.color.text.primary,
    '--local-exception-dialog-panel-bg': tokens.color.background.secondary,
    '--local-exception-dialog-input-bg': tokens.color.background.primary,
    '--local-exception-dialog-input-border': tokens.color.border.primary,
    '--local-exception-dialog-input-text': tokens.color.text.primary,
    '--local-exception-dialog-placeholder': tokens.color.text.placeholder,
    '--local-exception-dialog-error': tokens.color.text.errorPrimary,
    '--local-exception-dialog-gap': tokens.spacing.lg,
    '--local-exception-dialog-field-gap': tokens.spacing.sm,
    '--local-exception-dialog-pad': tokens.spacing.xl,
    '--local-exception-dialog-panel-pad': tokens.spacing.md,
    '--local-exception-dialog-radius': tokens.radius.md,
    '--local-exception-dialog-title-size': tokens.font.size.textLg,
    '--local-exception-dialog-body-size': tokens.font.size.textSm,
    '--local-exception-dialog-title-weight': tokens.font.weight.semibold,
    '--local-exception-dialog-label-weight': tokens.font.weight.medium,
    '--local-exception-dialog-line-title': tokens.lineHeight.textLg,
    '--local-exception-dialog-line-body': tokens.lineHeight.textSm,
    '--local-exception-dialog-font': tokens.font.family.body,
    '--local-exception-dialog-focus': tokens.focusRing.default,
  },
};
